import { useBuildVersionCheck } from '@/hooks/useBuildVersionCheck';
import {
  BannerBar,
  type BannerBarProps,
} from '@/ui/components/pageBanner/PageBanner';
import type { BuildVersionState } from '@/utils/buildVersionCheck';
import { Button, Text } from '@payaca/ambrosia';
import { FC } from 'react';

type Notice = { variant: BannerBarProps['variant']; message: string };

const NOTICES: Partial<Record<BuildVersionState['status'], Notice>> = {
  'update-available': {
    variant: 'primary',
    message: 'A new version of Payaca is available.',
  },
  unsupported: {
    variant: 'warning',
    message:
      'You are using an unsupported version of Payaca. Some features may not work correctly.',
  },
};

const UpdateAvailableBanner: FC = () => {
  const buildVersion = useBuildVersionCheck();
  const notice = NOTICES[buildVersion.status];

  if (!notice) {
    return null;
  }

  return (
    <BannerBar variant={notice.variant} role="status">
      <Text as="span">
        {notice.message} Please{' '}
        <Button variant="link" onClick={() => window.location.reload()}>
          refresh
        </Button>
        .
      </Text>
    </BannerBar>
  );
};

export default UpdateAvailableBanner;
